import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Toaster } from "react-hot-toast";

// constants
import "./App.css";
import { SITE_URL, INITIAL_APP_LANG } from "@constant";
import LocaleStrings from "@language";
import jsonLanguageData from "@defaultlanguagedata";

// actions
import {
  checkEvent,
  fetchEventLanguages,
  fetchEventSettings,
} from "@mainaction";

// components
import Loader from "@loader";
import AdminLayout from "./layouts/admin";
import ReviewerLayout from "./layouts/reviewer";
// import AuthLayout from "./layouts/auth";

//hooks
import {
  useLocalStorage,
  LOCAL_STORAGE,
  LOGIN_SCREEN_NAME,
} from "@useLocalStorage";

const App = (props) => {
  const location = useLocation();
  const { session } = props;
  const [isEventLoad, setEventLoad] = useState("");
  const { setLocalStorage } = useLocalStorage();

  useEffect(
    () =>
      setLocalStorage(
        LOCAL_STORAGE.LOGIN_SCREEN,
        LOGIN_SCREEN_NAME.LAYOUT_SCREEN
      ),
    []
  );

  useEffect(() => {
    let lang = new URLSearchParams(location.search).get("lang");

    var hostname = window.location.hostname;
    var seocode = hostname.split(`.${SITE_URL}`)[0];
    props.checkEvent(session, seocode, (response) => {
      if (response.success) {
        props.fetchEventSettings(
          { ...session, eventid: response?.resource?.eventid },
          (res) => {
            setEventLoad("loadedcorrect");
            // logic to append tracking script //
            let trackingpixel = res?.data?.trackingpixel ?? "";
            // console.log("trackingpixel :- ", trackingpixel);

            if (trackingpixel && trackingpixel !== "") {
              let local_trackingpixel = JSON.parse(trackingpixel);
              let trackingpixel_header = local_trackingpixel?.header ?? "";
              let trackingpixel_footer = local_trackingpixel?.footer ?? "";

              if (trackingpixel_header !== "") {
                let head = document.querySelector("head");
                let innerScript = document
                  .createRange()
                  .createContextualFragment(trackingpixel_header);
                head.appendChild(innerScript);
              }
              if (trackingpixel_footer !== "") {
                let body = document.querySelector("body");
                let innerScript = document
                  .createRange()
                  .createContextualFragment(trackingpixel_footer);
                body.appendChild(innerScript);
              }
            }
            // logic to append tracking script //
          }
        );
        props.fetchEventLanguages(
          session,
          response?.resource?.eventid,
          (res) => {
            if (res?.success) {
              // Logic to set language file as per browser language
              let userLang = lang
                ? lang
                : res?.resource?.[0]?.languagekey
                ? res.resource[0].languagekey
                : INITIAL_APP_LANG;
              // console.log("userLang", userLang);

              let check = _.filter(
                res?.resource,
                (o) => o?.languagekey === userLang
              );

              if (check?.length > 0) {
                let newLangData = JSON.parse(check?.[0]?.languagejson);

                LocaleStrings.setContent({
                  [userLang]: {
                    ...jsonLanguageData,
                    ..._.cloneDeep(newLangData),
                  },
                });
              }
            }
          }
        );
      } else {
        setEventLoad("loadedwrong");
      }
    });
  }, []);

  return (
    <div className="App">
      {isEventLoad !== "" ? (
        <Routes>
          <Route
            path="/reviewer/*"
            element={
              <ReviewerLayout
                {...props}
                incorrectEvent={
                  isEventLoad === "loadedcorrect" &&
                  session &&
                  session.eventid &&
                  session.eventid !== ""
                    ? false
                    : true
                }
              />
            }
          />

          <Route
            path="/*"
            element={
              <AdminLayout
                {...props}
                incorrectEvent={
                  isEventLoad === "loadedcorrect" &&
                  session &&
                  session.eventid &&
                  session.eventid !== ""
                    ? false
                    : true
                }
              />
            }
          />

          {/* <Route path="/auth/*" element={<AuthLayout />} /> */}
        </Routes>
      ) : (
        <Loader />
      )}

      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          // Define default options
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },

          // Default options for specific types
          success: {
            duration: 3000,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    forceRefresh: state.forceRefresh, // whenever localStorage will update using useLocalStorage hook it will force to re render (!! DONT REMOVE THIS !!)
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { checkEvent, fetchEventLanguages, fetchEventSettings },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
